<template>
  <div v-if="isVisible">
    <!-- editor -->
    <dr-wrapper style="display: inline-block; position: relative" v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
      <v-tooltip bottom v-if="isExtendedPopUpMenu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            x-small
            tile
            outlined
            color="#ffa500"
            class="dr-button-extended-popup-editor-activator"
            @click.native="showMenu"
          >
            <v-icon color="#ffa500" x-small>mdi-menu</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('dr-button.showMenuContent') }}</span>
      </v-tooltip>
      <dr-button-spilka-ui-kit
        v-if="currentUIKit === 'spilkaUIKit'"
        :iconName="getExternalSourceField(model.IconName)"
        :caption="evaluateExpression(model.Caption)"
        :disabled="isDisabled"
        :outlined="isOutlined"
        :text="isText"
        @clickAction="actionOnClick"
      />
      <v-btn
        v-else
        :icon="model.IconMode"
        :disabled="isDisabled"
        :class="evaluateClasses(classes)"
        @click="actionOnClick"
        :color="evalColorExpression(model.Color)"
        :rounded="isRounded"
        :outlined="isOutlined"
        :plain="isPlain"
        :raised="isRaised"
        :text="isText"
      >
        <v-icon v-if="model.IconName">{{ getExternalSourceField(model.IconName) }}</v-icon>
        {{ evaluateExpression(model.Caption) }}
      </v-btn>
    </dr-wrapper>
    <!-- player -->
    <template v-else>
      <dr-button-spilka-ui-kit
        v-if="currentUIKit === 'spilkaUIKit'"
        :iconName="getExternalSourceField(model.IconName)"
        :caption="evaluateExpression(model.Caption)"
        :disabled="isDisabled"
        :outlined="isOutlined"
        :text="isText"
        :tooltipText="evaluateExpression(model.Tooltip)"
        :hiddenTooltip="isHiddenTooltip"
        @clickAction="actionOnClick"
        @showMenu="showMenu($event)"
      />
      <v-tooltip v-else :disabled="isHiddenTooltip" bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            :icon="model.IconMode"
            :disabled="isDisabled"
            :class="evaluateClasses(classes)"
            @click.stop="
              actionOnClick()
              showMenu($event)
            "
            :color="evaluateExpression(model.Color)"
            :rounded="isRounded"
            :outlined="isOutlined"
            :plain="isPlain"
            :raised="isRaised"
            :text="isText"
          >
            <v-icon v-if="model.IconName">{{ getExternalSourceField(model.IconName) }}</v-icon>
            {{ evaluateExpression(model.Caption) }}
          </v-btn>
        </template>
        <span>{{ evaluateExpression(model.Tooltip) }}</span>
      </v-tooltip>
    </template>

    <dr-button-popup-menu
      v-if="isPopUpMenu"
      :menuItems="menuItems"
      :menuOptions="popUpMenu"
      v-on:close-modeler-extended-menu="closeMenu('popUpMenu')"
      @callDataSourceAction="$emit('callDataSourceAction', $event)"
      v-bind="$props"
      v-on="wrapOn"
    />

    <dr-button-extended-pop-pup-menu
      v-if="isExtendedPopUpMenu"
      :menuOptions="extendedPopPupMenu"
      :isVisible="isVisible"
      v-on:close-modeler-extended-menu="closeMenu('extendedPopPupMenu')"
      v-on:change-popup-widgets-model="changePopUpWidgetsModel($event)"
      v-bind="$props"
      v-on="wrapOn"
    />
  </div>
</template>

<script>
  import en from '../../langs/dr-button/en.json'
  import ru from '../../langs/dr-button/ru.json'
  import uk from '../../langs/dr-button/uk.json'
  import inputMixin from '../../mixins/input-mixin'
  import baseMixin from '../../mixins/base-mixin'
  import microflowMixin from '../../mixins/microflow-mixin'
  import actionMixin from '../../mixins/actions-mixin'
  import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
  import drButtonSpilkaUiKit from './dr-button-spilka-ui-kit.vue'
  import drButtonExtendedPopPupMenu from './dr-button-extended-popup-menu.vue'
  import drButtonPopupMenu from './dr-button-popup-menu.vue'

  export default {
    mixins: [baseMixin, inputMixin, microflowMixin, actionMixin, widgetsWrapperMixin],
    components: { drButtonSpilkaUiKit, drButtonExtendedPopPupMenu, drButtonPopupMenu },
    data: () => ({
      menuItems: [],
      extendedPopPupMenu: {
        showMenu: false
      },
      popUpMenu: {
        showMenu: false
      }
    }),
    mounted() {
      if (this.model.OnClickAction.Type !== 'PopUpMenu') {
        return
      }

      for (let key in this.model.OnClickAction.Parameters) {
        this.menuItems.push({ popUpActionValue: key, title: this.model.OnClickAction.Parameters[key] })
      }
    },
    computed: {
      isExtendedPopUpMenu() {
        return this.model.OnClickAction?.Type === 'ExtendedPopUpMenu'
      },
      // Закрывать ли v-menu при клике на его содержимое
      isDontCloseMenuOnContentClick() {
        if (this.model.OnClickAction.isDontCloseMenuOnContentClick !== undefined) {
          return this.model.OnClickAction.isDontCloseMenuOnContentClick
        }
        return true
      },
      // styling a button
      isRounded() {
        return this.model.isRounded
      },
      isOutlined() {
        return this.model.isOutlined
      },
      isPlain() {
        return this.model.isPlain
      },
      isRaised() {
        return this.model.isRaised
      },
      isText() {
        return this.model.isText
      },
      isPopUpMenu() {
        return this.model.OnClickAction.Type === 'PopUpMenu'
      },
      // tooltip visibility
      isHiddenTooltip() {
        return this.model.Tooltip ? false : true
      }
    },
    methods: {

      showMenu(event) {
        if (!this.isPopUpMenu && !this.isExtendedPopUpMenu) {
          return
        }
        // Оперделение типа меню
        let menuType = this.isPopUpMenu ? 'popUpMenu' : 'extendedPopPupMenu'

        event.preventDefault()
        this[menuType].showMenu = false
        this[menuType].x = event.x
        this[menuType].y = event.y
        this.$nextTick(() => {
          this[menuType].showMenu = true
        })
      },

      closeMenu(menuType) {
        this[menuType].showMenu = false
      },
      // Сохранить новое содержимое ExtendedPopUpMenu
      changePopUpWidgetsModel(value) {
        this.model.OnClickAction.PopUpExtendedModel[0] = value
        this.$store.commit('needSaveModel', true)
      },
      actionOnClick() {
        this.invokeActionOnClick(this.model.OnClickAction)
      }
    },

    i18n: {
      messages: {
        uk,
        en,
        ru
      }
    }
  }
</script>

<style>
  .dr-button-extended-popup-editor-activator {
    background: #fff;
    width: 13px !important;
    height: 11px !important;
    position: absolute;
    z-index: 999;
    margin-top: 25px;
  }
</style>
